<template>
	<div class="Verification">
		<div class="head">
			<van-icon name="arrow-left" class="black_arrow" @click="$router.go(-1)" />
			<div class="title">重置密码</div>
		</div>
		<div class="EditingArea">
			<ul>
				<li>
					<van-field v-model="phone" center clearable :border="false" placeholder="请输入手机号/邮箱" />
				</li>
				<li class="authcodeInputWrapper">
					<van-field v-model="Verification" class="VerificationStyle fl" center clearable placeholder="请输入验证码" :border="false" />

					<div class="getVerificationStyle fr" @click="postAccountGetAuthCode" :style="{ color: Countdown > 0 ? '#BBBBBB' : '#333333' }">
						{{ VerificationStatus }}
					</div>

					<div class="clear"></div>
				</li>
			</ul>
		</div>
		<div class="OperatingSpace">
			<van-button round type="info" @click="verifyUser" :class="this.phone ? 'van-button--info' : 'noneVanButton'">下一步</van-button>
		</div>
	</div>
</template>
<script>
const isPhone = /^1(?:3[0-9]|4[5-9]|5[0-9]|6[12456]|7[0-8]|8[0-9]|9[0-9])[0-9]{8}$/
const isEmail = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/
export default {
	name: 'verification',
	data() {
		return {
			Countdown: 0,
			countdownInterval: null,
			phone: null,
			Verification: null,
			accountType: 'phone',
			mobile_prefix: '86',
		}
	},
	computed: {
		VerificationStatus() {
			if (this.Countdown) {
				return `重新获取 ${this.Countdown}s`
			} else {
				return '发送验证码'
			}
		},
	},
	created() {},
	mounted() {},
	methods: {
		judgeAccountType() {
			if (isPhone.test(this.phone)) {
				this.accountType = 'phone'
			}
			if (isEmail.test(this.phone)) {
				this.accountType = 'mail'
			}
		},
		verifyUser() {
			if (this.Verification.length != 6) {
				this.$notify({ type: 'warning', message: '请输入6位验证码' })
				return
			}
			let data = { account: this.phone, authCode: this.Verification, areaCode: this.mobile_prefix }
			this.$api.account_new.checkAuthCode(data).then((res) => {
				if (res.success) {
					this.toRouter(`/resetPassword_new?a=${this.phone}&b=${this.Verification}&accountType=${this.accountType}`)
				}
			})
		},
		toRouter(path) {
			this.$router.push({ path })
		},
		postAccountGetAuthCode() {
			if (this.Countdown > 0) return
			if (isPhone.test(this.phone) || isEmail.test(this.phone)) {
				this.Countdown = 60
				this.setCountdown()
				this.judgeAccountType()
				this.$sensors.track('UM_Click_Verification_Code_Button')
				if (this.accountType === 'phone') {
					this.$api.account_new.getPhoneAuthCode4ChangePwd({ phone: this.phone, areaCode: this.mobile_prefix })
				} else if (this.accountType === 'mail') {
					this.$api.account_new.getMailAuthCode4ChangePwd({ mail: this.phone })
				}
			} else {
				this.$notify({ type: 'warning', message: '手机号/邮箱格式有误,请检查一下吧' })
			}
		},
		setCountdown() {
			this.countdownInterval = setInterval(() => {
				this.Countdown--
				if (this.Countdown <= 0) {
					clearInterval(this.countdownInterval)
				}
			}, 1000)
		},
	},
	watch: {},
}
</script>
<style lang="stylus" scoped>
@import './css/forget.styl'
</style>
